module.exports = __webpack_public_path__ + "static/media/card_condo.7ca63136.jpg";